<template>
  <div>
    <editor-new-noedit v-model="config.settings.body_html" title="Content Text" />
  </div>
</template>

<script>
import EditorNewNoedit from '../EditorNewNoedit.vue';

export default {
  components: {
    EditorNewNoedit,
  },
  props: {
    callbackRemoveContent: {
      type: Function,
      default: () => {},
    },
    configSection: {
      type: Object,
      default: () => {},
    },
    callbackAddContent: {
      type: Function,
      default: () => {},
    },
    callbackRemoveSection: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      config: {},
    };
  },
  async created() {
    this.config = this.configSection;
  },
  methods: {},
};
</script>

<style lang="scss" scoped></style>
